import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import InvestmentTransactionBaseForm from './InvestmentTransactionBaseForm';

const InvestmentTransactionDividentForm = (props) => {
  const { formik } = props;

  useEffect(() => {
    formik.registerField('units', {
      validate: (value) => (typeof value === 'number' && value ? undefined : 'field is required'),
    });
    return () => {
      formik.unregisterField('units');
    };
  }, [formik]);

  return (
    <>
      <InvestmentTransactionBaseForm formik={formik} />

      <Box display='flex'>
        <TextField
          id='units'
          label='Shares quantity'
          type='number'
          inputProps={{ min: 1 }}
          sx={{ minWidth: 110 }}
          value={formik.values.units != null ? Math.abs(formik.values.units) : ''}
          onChange={(event) => formik.setFieldValue('units', event.target.value ? Number(event.target.value) : null)}
          error={Boolean(formik.submitCount > 0 && formik.errors.units)}
          helperText={(formik.submitCount > 0 && formik.errors.units) || 'Total shares received for each shares held'}
        />
      </Box>
    </>
  );
};

InvestmentTransactionDividentForm.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default InvestmentTransactionDividentForm;
